const normalizeLicenseSortText = (value) => String(value || "").trim().toLowerCase();

export const compareLicensesByState = (a, b) => {
  const aState = normalizeLicenseSortText(a?.state);
  const bState = normalizeLicenseSortText(b?.state);

  if (aState && !bState) return -1;
  if (!aState && bState) return 1;

  const stateCompare = aState.localeCompare(bState, undefined, { sensitivity: "base" });
  if (stateCompare !== 0) return stateCompare;

  const industryCompare = normalizeLicenseSortText(a?.industry).localeCompare(
    normalizeLicenseSortText(b?.industry),
    undefined,
    { sensitivity: "base" }
  );
  if (industryCompare !== 0) return industryCompare;

  const categoryCompare = normalizeLicenseSortText(a?.category).localeCompare(
    normalizeLicenseSortText(b?.category),
    undefined,
    { sensitivity: "base" }
  );
  if (categoryCompare !== 0) return categoryCompare;

  const aNumber = normalizeLicenseSortText(a?.licenseNumber || a?.license_number);
  const bNumber = normalizeLicenseSortText(b?.licenseNumber || b?.license_number);
  return aNumber.localeCompare(bNumber, undefined, { numeric: true, sensitivity: "base" });
};

export const sortLicensesByState = (licenses) =>
  Array.isArray(licenses) ? [...licenses].sort(compareLicensesByState) : [];

export const sortStateCodes = (states) =>
  Array.isArray(states)
    ? [...states]
      .map((state) => String(state || "").trim())
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
    : [];
